export default __webpack_public_path__ + "static/media/peachcar.b21e71dd.gif";